import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { environment } from 'environments/environment';

import { KeyValuePairModel } from '../models/common.models';
import {
  GetBottleDetailsResponseModel,
  IWineBottleSummary,
  UpdateBottleRequestModel,
  UpdatedLandedUnitPriceModel,
} from '../models/wine-bottles.models';

@Injectable({
  providedIn: 'root',
})
export class BottleService {
  private searchEvent = new Subject<any>();

  searchEvent$ = this.searchEvent.asObservable();

  private get baseApiUrl(): string {
    return environment.storageManagementUrl;
  }

  constructor(private http: HttpClient) {}

  getClosureTypesLookupV1(): Observable<KeyValuePairModel<number>[]> {
    const url = `${this.baseApiUrl}/v1/ReferenceData/ClosureTypes/lookup`;
    return this.http.get<KeyValuePairModel<number>[]>(url, {});
  }

  getBottleSummaryByLabelCodeV1(labelCode: string): Observable<IWineBottleSummary> {
    const url = `${this.baseApiUrl}/V1/WineBottle/${labelCode}`;
    return this.http.get<IWineBottleSummary>(url);
  }

  getBottleSummaryByBottleIdV1(bottleId: number): Observable<GetBottleDetailsResponseModel> {
    const url = `${this.baseApiUrl}/V1/WineBottle/${bottleId.toString()}`;
    return this.http.get<GetBottleDetailsResponseModel>(url);
  }

  updateBottleV1(id: number, model: UpdateBottleRequestModel): Observable<void> {
    const url = `${this.baseApiUrl}/v1/WineBottle/${id}`;
    return this.http.put<void>(url, model);
  }

  uploadBottlePhotoV1(id: number, file: File): Observable<void> {
    const url = `${this.baseApiUrl}/v1/WineBottle/${id}/Photo`;
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<void>(url, formData);
  }

  bulkUpdateBottleLandingUnitCost(model: UpdatedLandedUnitPriceModel) {
    const url = `${this.baseApiUrl}/v1/WineBottle/LandedUnitCost`;
    return this.http.put<void>(url, model);
  }
}
